module.exports = __webpack_public_path__ + "imgs/product-new.1f4beee715a13e6b8b4ec5af93a1576c.svg";